import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

// Firebase imports
import { environment } from '../environments/environment';

import {
  MsalService,
  MsalGuard,
  MsalInterceptor,
  MSAL_INSTANCE,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
    MsalService,
    MsalGuard,
    MsalInterceptor,
    {
      provide: MSAL_INSTANCE,

      useFactory: () => {
        return new PublicClientApplication({
          auth: {
            clientId: environment.microsoftOAuth.clientId,
            authority: `https://login.microsoftonline.com/${environment.microsoftOAuth.tenant}`,
            redirectUri: environment.microsoftOAuth.redirectUri,
          },

          cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage,
            storeAuthStateInCookie: false,
          },

          system: {
            loggerOptions: {
              loggerCallback: (
                level: LogLevel,
                message: string,
                containsPii: boolean
              ) => {
                if (containsPii) {
                  return;
                }

                switch (level) {
                  case LogLevel.Error:
                    console.error(message);
                    break;

                  case LogLevel.Warning:
                    console.warn(message);
                    break;

                  case LogLevel.Info:
                    console.info(message);
                    break;

                  case LogLevel.Verbose:
                    console.debug(message);
                    break;
                }
              },
            },
          },
        });
      },
    },
  ],
};
